import { useState } from "react";
import axios from "axios";
import { useLocalStorage } from "./useLocalStorage";

const useGetVideo = (url) => {
  const [video, setVideo] = useLocalStorage("video", "");
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);
  const [novideo, setNoVideo] = useState(false);

  async function getVideo() {
    try {
      const response = await axios.get(url);
      const result = response.data.results;

      if (!result.length) {
        setNoVideo(true);
      } else {
        setNoVideo(false);
        setVideo(result[0]);
      }
      setLoading(false);
      setError(false);
    } catch (error) {
      setLoading(false);
      setError(error);
    }
  }
  return { video, loading, error, novideo, getVideo };
};

export default useGetVideo;
